// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"em_a bhe_a bhe_x bhe_j bhe_u bhe_bc bhe_qj bhe_vt"};